import { TypographyOptions } from '@mui/material/styles/createTypography';
import paletteOptions from './palette-options';

const typographyOptions: TypographyOptions = {
  fontFamily: [
    'Montserrat',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  button: {
    textTransform: 'initial',
    fontWeight: 600,
  },
  h1: {
    fontSize: '1.6rem',
    fontWeight: 600,
  },
  h2: {
    fontSize: '1.4rem',
    fontWeight: 600,
    color: paletteOptions.text.primary,
  },
  h3: {
    fontSize: '1.2rem',
    fontWeight: 600,
    color: paletteOptions.text.primary,
  },
  h4: {
    fontSize: '1rem',
    fontWeight: 600,
    color: paletteOptions.text.primary,
  },
  h5: {
    fontSize: '1rem',
  },
  h6: {
    fontSize: '0.8rem',
  },
};

export default typographyOptions;
